import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/operator/tenants/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/operator/users", replace: true });
  },
});
